import Vue from 'vue'
import {
  extend,
  configure,
  ValidationProvider,
  ValidationObserver
} from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import { i18n } from './i18n'

for (let rule in rules) {
  extend(rule, rules[rule])
}

extend('min_date_departure', {
  validate (value) {
    return Vue.moment(value).isSameOrAfter(new Date(), 'day')
  },
  message:
    'Data musi być większa lub równa od ' +
    Vue.moment(new Date()).format('DD/MM/YYYY')
})

extend('max_date_departure', {
  validate (value) {
    return Vue.moment(value).isBefore(
      Vue.moment(new Date()).add(30, 'days'),
      'day'
    )
  },
  message:
    'Data musi być mniejsza od ' +
    Vue.moment(new Date())
      .add(30, 'days')
      .format('DD/MM/YYYY')
})

extend('valid_pesel', {
  validate (value) {
    var year = parseInt(value.substring(0, 2), 10)
    var month = parseInt(value.substring(2, 4), 10) - 1
    var day = parseInt(value.substring(4, 6), 10)

    if (month > 80) {
      year = year + 1800
      month = month - 80
    } else if (month >= 60) {
      year = year + 2200
      month = month - 60
    } else if (month >= 40) {
      year = year + 2100
      month = month - 40
    } else if (month >= 20) {
      year = year + 2000
      month = month - 20
    } else {
      year += 1900
    }

    if (
      month < 0 ||
      month > 12 ||
      day < 0 ||
      day > 32 ||
      Vue.moment(new Date()).format('YYYY') - year < 18
    ) {
      return false
    }

    if (typeof value !== 'string') {
      return false
    }
    let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3]
    let sum = 0
    let controlNumber = parseInt(value.substring(10, 11))

    for (let i = 0; i < weight.length; i++) {
      sum += parseInt(value.substring(i, i + 1)) * weight[i]
    }
    sum = sum % 10
    return (10 - sum) % 10 === controlNumber
  },
  message: 'Nieprawidłowy PESEL'
})

extend('required_persons_located', {
  validate (value) {
    return value !== false
  },
  message:
    'Uwaga! Wszyscy uczestnicy wyjazdu muszą być na terenie PL, aby móc kupić polisę.'
})

extend('max_date_adult', {
  validate (value) {
    return Vue.moment(value).isBefore(
      Vue.moment(new Date()).subtract(18, 'year'),
      'day'
    )
  },
  message: 'Nieprawidłowa data urodzin, musisz być osobą pełnoletnią'
})

extend('max_date', {
  validate (value) {
    return Vue.moment(value).isBefore(Vue.moment(new Date()), 'day')
  },
  message: 'Nieprawidłowa data urodzin'
})

extend('before', {
  params: ['targetValue'],
  validate (value, { targetValue }) {
    if (targetValue && targetValue.length > 0) {
      return Vue.moment(new Date(value)).isSameOrBefore(targetValue, 'day')
    }
    return true
  },
  message: 'Data wyjazdu jest większa od Daty powrotu'
})
extend('after', {
  params: ['targetValue'],
  validate (value, { targetValue }) {
    if (targetValue && targetValue.length > 0) {
      return Vue.moment(new Date(value)).isSameOrAfter(targetValue, 'day')
    }
    return true
  },
  message: 'Data powrotu jest mniejsza od Daty wyjazdu'
})

extend('between_data_range', {
  params: ['targetValue'],
  validate (value, { targetValue }) {
    if (value && targetValue && value.length > 0 && targetValue.length > 0) {
      var days = Vue.moment(value).diff(Vue.moment(targetValue), 'days')
      if (days > 90) {
        return false
      }
    }
    return true
  },
  message: 'Maksymalny zakres ubezpieczenia to 90 dni'
})

configure({
  defaultMessage: (field, values) => {
    // override the field name.
    values._field_ = i18n.t(`fields.${field}`)

    return i18n.t(`validation.${values._rule_}`, values)
  }
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
